import Backbone from 'backbone';

export default Backbone.Model.extend({
  defaults: {
    title: '',
    content: '',
    open: false
  }
});



// WEBPACK FOOTER //
// webpack://grapesjs/src/modal_dialog/model/Modal.js